import script from "./CDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./CDialog.vue?vue&type=script&setup=true&lang=ts"

import "./CDialog.vue?vue&type=style&index=0&id=00e34029&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00e34029"]])

export default __exports__